import { Timestamp } from 'firebase/firestore';

export function isPast(value: Timestamp | null) {
	if (!value) return false;
	const now = Timestamp.now();
	return value < now;
}
